import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { AppStore } from '@aaa/emember/store-types';
import { getCanChangeMembership } from '@aaa/emember/store-account';
import { Pages } from '../../../constants/pages';

// plans, upgrade and associate add stay closed outside the renewal window where the club has
// MEMBERSHIP_CHANGES_ONLY_WHEN_DUE (shelby), so a bookmarked or typed url does not reach them either
export const canChangeMembership: CanActivateFn = () => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);

  return store
    .select(getCanChangeMembership)
    .pipe(tap((allow) => !allow && router.navigateByUrl(Pages.accountMembership)));
};

export default canChangeMembership;
